import { useCallback, useEffect, useState } from 'react';
import { Flex, TabsProps } from 'antd';
import classNames from 'classnames';

import useResizeLayout from '@Hooks/useResizeLayout';

import { useLocation } from 'react-router-dom';
import { ProfileMainSection } from './ProfileMainSection';
import styles from './profile-details-page.module.css';
import { getTabsItems } from './tabs';
import { Context, ContextType } from './context';
import { ProfileTab } from './types/ProfileTab.enum';

const { chosenTabWrapper: chosenTabWrapperClass } = styles;

const ProfileDetails: React.FC = () => {
  const { state } = useLocation();

  const { isMobile } = useResizeLayout();

  const [contextValue, setContextValue] = useState<ContextType>({});
  const [tabsItems, setTabsItems] = useState<TabsProps['items']>([]);
  const [activeTabKey, setActiveTabKey] = useState<string>(ProfileTab.Overview);

  useEffect(() => {
    const items: TabsProps['items'] = getTabsItems(chosenTabWrapperClass);
    setTabsItems(items);
  }, []);

  useEffect(() => {
    const activeTab = state?.activeTab as keyof typeof ProfileTab;
    if (activeTab) setActiveTabKey(ProfileTab[activeTab]);
  }, [state]);

  const handleTabsHeight = useCallback((height: number) => {
    setContextValue({
      tabsHeight: height,
    });
  }, []);

  const handleSelectActiveTab = useCallback((tabName: string) => {
    setActiveTabKey(tabName);
  }, []);

  return (
    <Context.Provider value={contextValue}>
      <Flex id="profile-page" vertical className={styles.profilePage}>
        <ProfileMainSection
          activeTabKey={activeTabKey}
          tabsItems={tabsItems}
          onTabsHeightCalculated={handleTabsHeight}
          handleSelectActiveTab={handleSelectActiveTab}
        />
        <div
          className={classNames(
            chosenTabWrapperClass,
            isMobile ? 'mobile' : null
          )}
        />
      </Flex>
    </Context.Provider>
  );
};

export default ProfileDetails;
